/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2022-11-16 09:41:41
 * @LastEditors: Monkey
 * @LastEditTime: 2025-07-16 09:29:09
 */
//业务配置
//会合并至this.$CONFIG
//生产模式 public/config.js 同名key会覆盖这里的配置从而实现打包后的热更新
//为避免和SCUI框架配置混淆建议添加前缀 MY_
//全局可使用 this.$CONFIG.MY_KEY 访问

export default {
  //是否显示第三方授权登录
  MY_SHOW_LOGIN_OAUTH: false,

  // 是否开启设置
  LAYOUT_SETTING_FLAG: false,

  // 验证
  VALIDATE: {
    TYPE: 'TIANAI_CAPTCHA'
    // TYPE: 'LUOSIMAO',
    // API_KEY: '4e45afd28b64f9d6644068906e91c44d' // prod
    // API_KEY: '4fd025e03736a8c61a445bc0284663c5' // test
  }
}
